// extracted by mini-css-extract-plugin
module.exports = {"infoRow":"ArtistIndexOverviewInfoRow-infoRow-2wJsH","icon":"ArtistIndexOverviewInfoRow-icon-3vOXK"};